import mixinActions from '../core/actions';
import mixinGetters from '../core/getters/index';
import feedGetters from '../core/getters/feed';
import mixinMutations from '../core/mutations/index';
import feedMutations from '../core/mutations/feed';
import constants from 'Helpers/constants';
import Vue from 'vue';
import feedActions from '~/store/core/actions/feed';

export default {
    namespaced: true,
    state: {
        response: [],
        todayFeeds: [],
        earlyFeeds: [],
        extraFeeds: [],
        repositoryName: 'todayFeeds',
        version: {
            todayFeeds: 0,
            earlyFeeds: 0,
        },
        filters: {
            line: constants.LINE_MAIN,
            customLeagueIds: null,
            marketId: constants.DBALL_MARKET_TODAY,
            dateTo: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10),
            customEventId: null,
            search: null,
            betCustomEventIds: [], //Open BetDialogs
            periodTypeId: constants.GAME_PERIOD_FT,
            customColumns: [],
            isFantasyExclude: true,
            isPositionOnly: false,
        },
        todayFeedLeague: {},
        earlyFeedLeague: {},
        todayFeedTeam: {},
        earlyFeedTeam: {},
        isShowExtraFilters: false,
        betFeedData: {},
        gamesIdx: { todayFeeds: [], earlyFeeds: [] },
    },

    mutations: {
        ...mixinMutations(),
        ...feedMutations('FeedDballModule'),

        setBetFeedData(state, data) {
            if (data.betFeedData === null) {
                Vue.delete(state.betFeedData, data.idx);
            } else {
                Vue.set(state.betFeedData, data.idx, data.betFeedData);
            }
        },

        setTodayList(state, todayFeeds) {
            state.todayFeeds = todayFeeds;
        },

        setEarlyList(state, earlyFeeds) {
            state.earlyFeeds = earlyFeeds;
        },
        setVersion(state, data) {
            if (data.repositoryName === 'todayFeeds') {
                state.version.todayFeeds = data.version;
            } else {
                state.version.earlyFeeds = data.version;
            }
        },
    },

    getters: {
        ...mixinGetters(),
        ...feedGetters(),

        getTodayList(state) {
            return state.todayFeeds;
        },
        getEarlyList(state) {
            return state.earlyFeeds;
        },
        getBetFeedData(state) {
            return state.betFeedData;
        },
        getMarketName(state) {
            return state.filters.marketId === constants.DBALL_MARKET_TODAY ? 'todayFeed' : 'earlyFeed';
        },
        getTodayVersion(state) {
            return state.version.todayFeeds;
        },
        getEarlyVersion(state) {
            return state.version.earlyFeeds;
        },
        getTodayFeedLeague(state) {
            return state.todayFeedLeague;
        },
        getEarlyFeedLeague(state) {
            return state.earlyFeedLeague;
        },
        getTodayFeedTeam(state) {
            return state.todayFeedTeam;
        },
        getEarlyFeedTeam(state) {
            return state.earlyFeedTeam;
        },
    },

    actions: {
        ...mixinActions('feedDball'),
        ...feedActions('feedDball'),
    },
};
